import { Column, Control, Field, Input } from "@allxsmith/bestax-bulma";
import React, { useState } from "react";

function useInput({ type, label, initialValue, currency, onChange, size, ...inputProps}) {
  initialValue = initialValue || (type === "date" ? undefined : "");
  const onChangeFunc = onChange ? function(e) { onChange(e); setValue(e.target.value);} : (e => setValue(e.target.value))
  const [value, setValue] = useState(initialValue);
  const input = (
    <Column size={size}>
      <Field>
        <label className="label">{label}</label>
        <Control iconLeft={!!currency}>
          <Input
            value={value}
            onChange={onChangeFunc}
            type={type}
            {...inputProps}
          />
        </Control>
      </Field>
    </Column>
  );
  return [value, input, setValue];
}

export default useInput;
